/**
 * Persists across full-page navigation (login redirect). Cleared when warm caches are ready
 * or after a safety timeout (see WorkspaceSetupGate).
 */
export const WORKSPACE_SETUP_SESSION_KEY = 'trodo_workspace_setup_active';

export function markWorkspaceSetupPending() {
  try {
    sessionStorage.setItem(WORKSPACE_SETUP_SESSION_KEY, String(Date.now()));
  } catch {
    /* ignore */
  }
}

export function clearWorkspaceSetupPending() {
  try {
    sessionStorage.removeItem(WORKSPACE_SETUP_SESSION_KEY);
  } catch {
    /* ignore */
  }
}

export function isWorkspaceSetupPending() {
  try {
    return sessionStorage.getItem(WORKSPACE_SETUP_SESSION_KEY) != null;
  } catch {
    return false;
  }
}
